module.exports = "<div class=\"login-info\">\r\n    <!-- <span *ngIf=\"user?.picture\"><a (click)=\"toggleShortcut()\">\r\n\t   <img [src]=\"user.picture\" alt=\"me\"\r\n          class=\"online\"/><span>{{user.username }}</span> <i class=\"fa fa-angle-down\"></i>\r\n    </a>\r\n   </span> -->\r\n    <span><a (click)=\"toggleShortcut()\">\r\n            <img src=\"assets/img/avatars/ezio.jpg\" alt=\"me\" class=\"online\" /><span>Ezio C.</span> <i class=\"fa fa-angle-down\"></i>\r\n        </a>\r\n    </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/login-info/login-info.component.html
// module id = 885
// module chunks = 29